import { DialogueUIConfig, DialogueUIOptionConfig } from "../../components/ui/YouRespondUI";
import { NurseStationComputerUIConfig } from "../../components/ui/NurseStationComputerUI";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { Segments } from "../../cvp-webgames-core/Scenario/Segments";
import { constants } from "../../misc/constants";
import { CalmBaseScenario, ScoreType, Window508Type } from "../CalmBaseScenario";
import Scenario5 from "./Scenario5";
import { NurseStationComputerSingleQustionUIConfig } from "../../components/ui/NurseStationComputerSingleQuestionUI";

export default class Scenario5Part3 extends BaseScenarioPart<CalmBaseScenario> {

	private partIndx = 0;
	chapterIds = {
		scenario5_1a_s4b: 'CALM - Scenario 5 - 2A - Segment 4B',
		scenario5_2A_s5: 'CALM - Scenario 5 - 2A - Segment 5',
		scenario5_2A_s6: 'CALM - Scenario 5 - 2A - Segment 6',
		scenario5_2A_s7: 'CALM - Scenario 5 - 2A - Segment 7',
		scenario5_3A_s8: 'CALM - Scenario 5 - 3A - Segment 8',
	}

	constructor(scenario: Scenario5, private onDone: () => void) {
		super(scenario);
		CalmBaseScenario.partIndx = this.partIndx;
	}

	public get videoUrl(): string[] {
		return ['./assets/videos/scenario5/calm-scenario5-avatar' + this.scenario.avatarIndx + '.mp4'];
	}

	public get partId(): string {
		return constants.scenarios.scenario5.parts.level5Part2.id;
	}

	public start() {
		const context = this;
		context.segment1Step2DecideAction();
	}

	private segment1Step2DecideAction() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		this.scenario.dialog(
			'CN-C01-L3-000a',
			[{
				text: 'Look up policies on the nurses’ station computer. ',
				feedback: 'Assume you have to respond immediately. Let\'s go to the Medical Emergency Code room now.',
				scoreType: ScoreType.Zero,
				isCorrect: false // Rank Zero
			}, {
				text: 'Go to Medical Emergency Code room.',
				scoreType: ScoreType.Best,
				isCorrect: true // Rank best_s
			}, {
				text: ' Determine re-staffing for Medical Emergency Code primary RN.',
				feedback: 'Assume you have to respond immediately. Let\'s go to the Medical Emergency Code room now.',
				scoreType: ScoreType.Zero,
				isCorrect: false // Rank Zero
			}],
			(selectedOption: DialogueUIOptionConfig, config: DialogueUIConfig) => {
				context.scenario.evaluateAnswer_s(selectedOption, () => {
					context.scenario.stopAmbientLoop(this.scenario.audioHall);
					context.segment2Step1HeatherGreets();
				}, () => {
					context.scenario.stopAmbientLoop(this.scenario.audioHall);
					context.segment2Step1HeatherGreets();
				}
				)
				context.scenario.evaluateAnswerForSummative(selectedOption, {
					onOptionSelected: () => { },
					options: [
						{
							text: 'Look up policies on the nurses’ station computer. ',
							scoreType: ScoreType.Zero,
							isCorrect: false // Rank Zero
						}, {
							text: 'Go to Medical Emergency Code room.',
							scoreType: ScoreType.Best,
							isCorrect: true // Rank best_s
						}, {
							text: ' Determine re-staffing for Medical Emergency Code primary RN.',
							scoreType: ScoreType.Zero,
							isCorrect: false // Rank Zero
						}
					],
					aarScenarioID: 0,
					aarSectionID: 0,
					aarCollectionID: [config.selectedAnswer]
				}, () => { }, context.partIndx)
			})
		context.scenario.updateObjective('How should you respond?');
	}

	private segment2Step1HeatherGreets() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.displayHeader();
		this.scenario.playAudio(this.scenario.audioHallToRoom,false);
		context.playVideoChapter(this.chapterIds.scenario5_1a_s4b, () =>  
			context.segment2Step2FirstResponse())
	}

	private segment2Step2FirstResponse() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		this.scenario.dialog(
			'CN-C01-S1-020e', //CN-C01-L3-020a is Heather's line, but this comes after that line and is what prompts the action to be taken
			[{
				text: 'Re-staff RN Heather’s patients.',
				feedback: 'You chose to re-staff RN Heather\'s patients. However, go ahead and move the family members out of the room first.',
				scoreType: ScoreType.Zero,
				isCorrect: false // Rank Zero
			}, {
				text: 'Identify a family representative to stay in the room.',
				scoreType: ScoreType.Best,
				isCorrect: true // Rank best_s
			}],
			(selectedOption: DialogueUIOptionConfig, config: DialogueUIConfig) => {
				context.scenario.evaluateAnswer_s(selectedOption, () => {
					context.segment3Step1JamieResponds();
				}, () => {
					context.segment3Step1JamieResponds();
				}
				)
				context.scenario.evaluateAnswerForSummative(selectedOption, {
					onOptionSelected: () => { },
					options: [
						{
							text: 'Re-staff RN Heather’s patients.',
							scoreType: ScoreType.Zero,
							isCorrect: false // Rank Zero
						}, {
							text: 'Identify a family representative to stay in the room.',
							scoreType: ScoreType.Best,
							isCorrect: true // Rank best_s
						}
					],
					aarScenarioID: 0,
					aarSectionID: 1,
					aarCollectionID: [config.selectedAnswer]
				}, () => { }, context.partIndx)
			})
		context.scenario.updateObjective('How should you respond?');
		this.scenario.playAmbientLoop(this.scenario.audioRoom, true);
	}

	private segment3Step1JamieResponds() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.playVideoChapter(context.chapterIds.scenario5_2A_s5, () => {
			this.segment3Step2SelectResponse();
		});
		context.scenario.updateObjective('');
	}

	private segment3Step2SelectResponse() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		this.scenario.dialog(
			'CN-C01-L3-070a-1', //CN-C01-L3-020a is Heather's line, but this comes after that line and is what prompts the action to be taken
			[{
				text: 'I’ll escort the family members out of the room myself. ',
				feedback: 'You chose to escort the family members out of the room yourself. Let\'s assume that you delegated LPN Jamie to escort the family members out of the room.',
				scoreType: ScoreType.Zero,
				isCorrect: false // Rank Zero
			}, {
				text: 'I’ll tell LPN Jamie to escort the family members out of the room.',
				scoreType: ScoreType.Best,
				isCorrect: true // Rank best_s
			}],
			(selectedOption: DialogueUIOptionConfig, config: DialogueUIConfig) => {
				context.scenario.evaluateAnswer_s(selectedOption, () => {
					context.scenario.stopAmbientLoop(this.scenario.audioRoom); 
					context.segment4Step1JamieEscort();
				}, () => {
					context.scenario.stopAmbientLoop(this.scenario.audioRoom); 
					context.segment4Step1JamieEscort();
				}
				)
				context.scenario.evaluateAnswerForSummative(selectedOption, {
					onOptionSelected: () => { },
					options: [
						{
							text: 'I’ll escort the family members out of the room myself.',
							scoreType: ScoreType.Zero,
							isCorrect: false // Rank Zero
						}, {
							text: 'I’ll tell LPN Jamie to escort the family members out of the room.',
							scoreType: ScoreType.Best,
							isCorrect: true // Rank best_s
						}
					],
					aarScenarioID: 0,
					aarSectionID: 2,
					aarCollectionID: [config.selectedAnswer]
				}, () => { }, context.partIndx)
			})
		context.scenario.updateObjective('How should you respond?');
	}

	private segment4Step1JamieEscort() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		this.scenario.playAudio(this.scenario.audioRoomToHall,false);
		context.playVideoChapter(context.chapterIds.scenario5_2A_s6, () => {
			this.segment5Step2Restaffing();
			this.scenario.playAmbientLoop(this.scenario.audioHall, true);
		});
		context.scenario.updateObjective('');
	}

	private segment5Step2Restaffing() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		this.scenario.showStaffingPlanUI((data: any) =>
			context.scenario.evaluateAnswerForSummativeStaffingPlan(data.avatars[0], data.avatars[1], data.avatars[2], data.avatars[3], data.avatars[4], context.partIndx, () =>
				context.segment5Step3Question(), // data.avatars[0].currentCount = what heather has
			))
		context.scenario.updateObjective('How many patients does your staff have?');
	}

	private segment5Step3Question() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		var selectedAnswer = 0;
		context.scenario.updateObjective('')

		context.scenario.update508Window(Window508Type.NurseStationComputerSingleQuestionUI);
		context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.NurseStationComputerSingleQuestionUI, {
			title: 'When considering how to re-staff members, which decision helps ensure patient safety? Select the best answer.', // need to close regardless of right or wrong
			isSummative: true,
			options: [
				{
					text: 'Assign extra patients to a nurse who already has a patient in isolation.',
					scoreType: ScoreType.Zero,
					isSummative: true,
					isCorrect: false	// Rank Zero
				},
				{
					text: 'Assign extra patients to a nurse who is exhibiting evidence of being overwhelmed.',
					scoreType: ScoreType.Zero,
					isSummative: true,
					isCorrect: false	//Rank Zero
				},
				{
					text: 'Assign patients with low acuity levels to a nurse who is training and may lack confidence.',
					scoreType: ScoreType.Best,
					isSummative: true,
					isCorrect: true	// Rank Best_S
				},
				{
					text: 'Assign additional patients to a nurse who already has patients on opposite ends of the floor.',
					scoreType: ScoreType.Zero,
					isSummative: true,
					isCorrect: false // Rank Zero
				}
			],
			onChoiceSelected: (selectedOption: DialogueUIOptionConfig, selectedIndex: number) => {
				//context.scenario.evaluateAnswer(selectedOption, () => {}, context.partIndx);
				// 	context.scenario.evaluateAnswerForSummative(selectedOption, {
				// 		onOptionSelected: ()=> {},
				// 		options:[
				// 			{
				// 				text: 'Assign extra patients to a nurse who already has a patient in isolation.',
				// 				scoreType: ScoreType.Zero,
				// 				isCorrect: false	// Rank Zero
				// 			},
				// 			{
				// 				text: 'Assign extra patients to a nurse who is exhibiting evidence of being overwhelmed.',
				// 				scoreType: ScoreType.Zero,
				// 				isCorrect: true	//Rank Zero
				// 			},
				// 			{
				// 				text: 'Assign patients with low acuity levels to a nurse who is training and may lack confidence.',
				// 				scoreType: ScoreType.Best,
				// 				isCorrect: true	// Rank Best_S
				// 			},
				// 			{
				// 				text: 'Assign additional patients to a nurse who already has patients on opposite ends of the floor.',
				// 				scoreType: ScoreType.Zero,
				// 				isCorrect: true // Rank Zero
				// 			}
				// 		],
				// 	}, () => { }, context.partIndx)
				selectedAnswer = selectedIndex;
			},

			onClosed: (config: NurseStationComputerSingleQustionUIConfig) => {
				config.aarScenarioID = 4;
				config.aarSectionID = 1;
				config.selectedOption = selectedAnswer;
				context.scenario.evaluateAnswerForSummativeNurseStationComputerSingleQuestion(config, () => {
					context.segment6Step1GoInformStaff();
				});
			},
		})

		context.scenario.updateObjective('');
	}

	private segment6Step1GoInformStaff() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.playVideoChapter(context.chapterIds.scenario5_2A_s7, () => {
			this.segment7Step1StaffConfirm();
		});
		context.scenario.updateObjective('Inform the staff of the Re-staffing changes');
	}

	private segment7Step1StaffConfirm() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.playVideoChapter(context.chapterIds.scenario5_3A_s8, () => {
			this.onDone();
		});
		context.scenario.updateObjective('');
	}
}